import { QM } from '../types'
import { handleError } from '../../utils/error'
import Api from '../../api'

export const openQmDialog = () => ({
  type: QM.OPEN_DIALOG,
})

// dialog close
export const closeQmDialog = () => ({
  type: QM.CLOSE_DIALOG,
})

// reset upload flag
export const resetQmState = () => ({
  type: QM.RESET,
})

export const submitQmUpload = payload => {
  return dispatch => {
    dispatch({ type: QM.UPLOAD_FETCHING })

    return Api.QM.uploadWeights(payload)
      .then(res => {
        if (res.status === 200) {
          dispatch({
            type: QM.UPLOAD_SUCCESS,
            payload: {
              thresholdUpdates: res.data?.threshold_updates || null,
              thresholdMessage:
                res.data?.msg || 'QM file uploaded successfully',
            },
          })
        }
      })
      .catch(err => {
        const status = err?.response?.status
        const msg = err?.response?.data?.error
        console.error(msg)

        if (status === 400) {
          dispatch({
            type: QM.UPLOAD_ERROR,
            payload: msg ?? 'Missing required fields',
          })
          return
        }

        if (status === 413) {
          dispatch({
            type: QM.UPLOAD_ERROR,
            payload: msg ?? 'CSV file is too large',
          })
          return
        }

        dispatch({
          type: QM.UPLOAD_ERROR,
          payload: msg ?? 'Server error while uploading QM file',
        })
      })
  }
}
